import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const StyledComment = styled.div<{ isReply?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isReply }) => (isReply ? '40px 1fr' : '1fr')};
`;

export const TreeLine = styled.div<{ isFirst?: boolean }>`
  position: relative;
  width: 40px;
  height: 100%;

  &:after {
    content: '';
    position: absolute;
    top: ${({ isFirst }) => (isFirst ? '4px' : '-3px')};
    left: 13px;
    width: 20px;
    height: ${({ isFirst }) => (isFirst ? '22px' : '29px')};
    border-bottom-left-radius: 8px;
    border-bottom: 1px solid ${themeStyle.varInkLight};
    border-left: 1px solid ${themeStyle.varInkLight};
  }
`;

export const CommentWrapper = styled.div<{ isReply?: boolean }>`
  display: flex;
  flex-direction: column;
  border-top: ${({ isReply }) =>
    isReply ? 'none' : `1px solid ${themeStyle.varInkLight}`};
`;

export const CommentContainer = styled.div`
  width: 100%;
  padding-top: 10px;
  border-radius: 5px;
  display: flex;
`;

export const CommentContentWrapper = styled.div`
  width: 100%;
  margin-left: 10px;
  margin-top: -2px;

  p {
    margin: 0;
  }
`;

export const CommentTextWrapper = styled.div`
  padding-bottom: 2px;
`;

export const CommentText = styled.p`
  word-break: break-word;
  color: ${themeStyle.varInkMain};
  font-size: ${themeStyle.fontSize12};
  font-weight: ${themeStyle.fontMedium};
  line-height: 17px;
`;

export const AuthorName = styled.span`
  cursor: pointer;
  font-weight: ${themeStyle.fontBold};
  margin-right: 5px;
`;

export const CommentActions = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${themeStyle.varInkMedium};
  font-size: ${themeStyle.fontSize11};
  font-weight: ${themeStyle.fontMedium};
  line-height: 1.6;
`;

export const CommentDelete = styled.span`
  cursor: pointer;
  color: ${themeStyle.varInkMedium};
  font-size: ${themeStyle.fontSize11};
  line-height: 1.6;
  margin-left: auto;
`;

export const CommentReply = styled(CommentDelete)`
  font-weight: ${themeStyle.fontBold};
`;

export const StyledDeletedMessage = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  color: ${themeStyle.varInkMedium};

  svg {
    margin-top: 2px;
  }
`;

export const StyledMention = styled.span`
  color: ${themeStyle.varInkMedium};
  cursor: pointer;
  position: relative;

  // it makes mention and its popover connected
  &:hover:after {
    bottom: -20px;
    content: '';
    height: 20px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;
